import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Row, Col, Breadcrumb, BreadcrumbItem } from 'reactstrap';

export default function Post() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Row>
      <Col xs="12" md="8" className="padded-md" style={{ margin: '0 auto' }}>
        <div>
          <Breadcrumb>
            <BreadcrumbItem onClick={() => navigate(-1)} className="pointer">
              Posts
            </BreadcrumbItem>
            <BreadcrumbItem active>{location.state.postTitle}</BreadcrumbItem>
          </Breadcrumb>
        </div>
        <img
          src={location.state.coverImg}
          className="img-responsive rounded-sm"
        />
        <br />
        <br />
        <h1>{location.state.postTitle}</h1>
        <h4>{location.state.postSubtitle}</h4>
        <small className="text-grey">
          Por Diestro Corleone,{' '}
          {new Date(
            location.state.createdDate.seconds * 1000
          ).toLocaleDateString('en-GB')}
        </small>
        <br />
        <br />
        <div
          dangerouslySetInnerHTML={{
            __html: location.state.content,
          }}
        />
      </Col>
    </Row>
  );
}
